export enum PaymentRequestReason {
    Other = 'Other',
    PaymentCardDeclined = 'PaymentCardDeclined',
    PaymentCardMissing = 'PaymentCardMissing',
}
